import { centeredBoldGrayForHeaders, left } from "src/app/util/excelStyles";
import { Rows } from "../../../interfaces";
import { formats, getCell, withCellStyles } from "../../../utils";
import { FundPerformance } from "src/app/domain/fund-performance/dto/FundPerformance";
import {
  FIRST_ROW_FP_ACTIVE_TABLE,
  HEADERS_FOR_DISPLAY_FP_ACTIVE_TABLE,
  HEADERS_FOR_LOGIC_FP_ACTIVE_TABLE,
} from "./headders";

export const getPreparedData = (fundPerformances: FundPerformance[]): Rows => {
  const newData: Rows = [];
  const headersForDisplay = HEADERS_FOR_DISPLAY_FP_ACTIVE_TABLE;
  const firstRow = FIRST_ROW_FP_ACTIVE_TABLE;
  const designedHeaderRow = [];
  newData.push(firstRow);
  headersForDisplay.forEach((header) => designedHeaderRow.push(withCellStyles(header, centeredBoldGrayForHeaders)));
  newData.push(designedHeaderRow);
  const mainRows = getMainRows(fundPerformances, HEADERS_FOR_LOGIC_FP_ACTIVE_TABLE);
  newData.push(...mainRows);
  resetData();
  return newData;
};

const getMainRows = (fundPerformances: FundPerformance[], headers: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = fundPerformances.map((fp) => getNewMappping(fp));

  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};

const getNewMappping = (fp: FundPerformance): object => {
  const body = {
    'Period': fp.period,
    'Total companies': fp.totalCompanyAmount !== 0 ? fp.totalCompanyAmount : '-',
    'Investment': getCell({
      v: fp.totalCost,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value': getCell({
      v: fp.totalFmv,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Gain/(loss)': getCell({
      f: `D${currentRowIndex}-C${currentRowIndex}`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC': getCell({
      f: `IFERROR(D${currentRowIndex}/C${currentRowIndex},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'IRR': getCell({
      v: fp.calculatedGrossIrr,
      z: formats.percentsNoSpace,
      t: 'n',
    }),
    'empty(0)': null,

    'Companies(1)': fp.activeCompaniesAmount !== 0 ? fp.activeCompaniesAmount : '-',
    'Investment(1)': getCell({
      v: fp.activeCost,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(1)': getCell({
      v: fp.activeFmv,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Unrealized gain/(loss) (w escr. & earn-out)': getCell({
      f: `K${currentRowIndex}-j${currentRowIndex}`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(1)': getCell({
      f: `IFERROR(K${currentRowIndex}/j${currentRowIndex},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Escrow companies': getCell({
      v: fp.escrowCompaniesCount,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Escrow/earnout': getCell({
      v: fp.escrow,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'IRR(1)': getCell({
      v: fp.activeIrr,
      z: formats.percents,
      t: 'n',
    }),
    'empty(1)': null,

    'Companies(2)': fp.realizedCompaniesAmount !== 0 ? fp.realizedCompaniesAmount : '-',
    'Investment(2)': getCell({
      v: fp.realizedCost,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(2)': getCell({
      v: fp.realizedFmv,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Realized gain/(loss)': getCell({
      f: `T${currentRowIndex}-S${currentRowIndex}`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(2)': getCell({
      f: `IFERROR(T${currentRowIndex}/S${currentRowIndex},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'IRR(2)': getCell({
      v: fp.realizedIrr,
      z: formats.percentsNoSpace,
      t: 'n',
    }),
  };
  currentRowIndex++;
  return body;
};

// set current row indicator to start position
const resetData = (): void => {
  currentRowIndex = 3;
};
// current row indicator
let currentRowIndex = 3;
